import _pt from 'prop-types';
import { useRef, createContext } from 'react';
import { jsx } from '@emotion/core';
import PdfStore from "../stores/PdfStore.js";
import "../stores/index.js";
import useStores from "../hooks/useStores.js";
var StoresContext =
/*#__PURE__*/
createContext(null);

var createStores = function createStores(stores) {
  if (stores) {
    return stores;
  }

  var pdfStore = new PdfStore();
  return {
    pdfStore: pdfStore,
    assignmentStore: pdfStore.assignmentStore,
    signatureStore: pdfStore.signatureStore
  };
};

var StoresProvider = function StoresProvider(_ref) {
  var stores = _ref.stores,
      children = _ref.children;
  return jsx(StoresContext.Provider, {
    value: createStores(stores)
  }, children);
};

StoresProvider.displayName = "StoresProvider";
StoresProvider.propTypes = {
  stores: _pt.shape({}),
  children: _pt.node.isRequired
};

function withStores(WrappedComponent) {
  return function (props) {
    var maybeStores = useStores(true);
    var storesRef = useRef(createStores(maybeStores));
    return jsx(StoresProvider, {
      stores: storesRef.current
    }, jsx(WrappedComponent, props));
  };
}

export default StoresContext;
export { StoresProvider, createStores, withStores };